export default "__VITE_ASSET__BDeJD$Os__"